<template>
  <div class="page-add">
    <div class="add-title">{{ !editId ? "新增专题讲座" : "编辑专题讲座" }}</div>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="120px"
      :rules="rules"
      :model="ruleForm"
      ref="ruleForm"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="讲座类型：" prop="lectureType">
            <el-select
              class="form-select"
              v-model="ruleForm.lectureType"
              placeholder="请选择讲座类型"
              :disabled="!!editId && ruleForm.publishStatus == 1"
            >
              <el-option
                v-for="item in lectureTypeData"
                :key="item.paramKey"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="讲座主题：" prop="lectureName">
            <el-input
              v-model="ruleForm.lectureName"
              placeholder="请输入讲座主题"
              :disabled="!!editId && ruleForm.publishStatus == 1"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <el-form-item label="授课老师：" prop="teacher">
            <el-input
              style="width: 100%"
              v-model="ruleForm.teacher"
              placeholder="请输入授课老师姓名"
              :disabled="!!editId && ruleForm.publishStatus == 1"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <div class="unit_style">
            <div class="devide_line">—</div>
            <el-form-item
              class="period_form"
              prop="teacherUnitPosition"
              style="width: 100%"
            >
              <el-input
                v-model="ruleForm.teacherUnitPosition"
                placeholder="请输入授课老师职务职称"
                :disabled="!!editId && ruleForm.publishStatus == 1"
              >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="讲座时间：" prop="lectureTime">
            <el-date-picker
              style="width: 100%"
              v-model="ruleForm.lectureTime"
              type="date"
              clearable
              placeholder="请选择讲座时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :disabled="!!editId && ruleForm.publishStatus == 1"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="开始时间：" prop="lectureStartDate">
            <el-time-select
              placeholder="请选择开始时间"
              v-model="ruleForm.lectureStartDate"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '23:59',
                maxTime: ruleForm.lectureEndDate,
              }"
              :disabled="!!editId && ruleForm.publishStatus == 1"
              @change="timeChange"
            >
            </el-time-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="结束时间：" prop="lectureEndDate">
            <el-time-select
              placeholder="请选择结束时间"
              v-model="ruleForm.lectureEndDate"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '23:59',
                minTime: ruleForm.lectureStartDate,
              }"
              :disabled="!!editId && ruleForm.publishStatus == 1"
              @change="timeChange"
            >
            </el-time-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="学时(小时)："
            prop="lectureHours"
          >
            <el-input
              v-model="ruleForm.lectureHours"
              placeholder="请输入学时"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              @change="inputHours"
              :disabled="!!editId && ruleForm.publishStatus == 1"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="是否扫码签到：" prop="isScanSign">
            <el-radio-group v-model="ruleForm.isScanSign" :disabled="!!editId && ruleForm.publishStatus == 1">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.isScanSign == 1">
        <el-col :span="12">
          <el-form-item
            label="签到时间："
            prop="signDate"
            :rules="[
              {
                required: ruleForm.isScanSign == 1,
                validator: checkSignDate,
                trigger: 'blur',
              },
            ]"
          >
            <el-time-picker
              is-range
              v-model="ruleForm.signDate"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="HH:mm:ss"
              format="HH:mm:ss"
              :disabled="!!editId && ruleForm.publishStatus == 1"
            >
            </el-time-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="讲座地点：" prop="lecturePlace">
            <el-input
              v-model="ruleForm.lecturePlace"
              placeholder="请输入讲座地点"
              :disabled="!!editId && ruleForm.publishStatus == 1"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="主办单位：" prop="organizer">
            <el-input
              v-model="ruleForm.organizer"
              placeholder="请输入主办单位"
              :disabled="!!editId && ruleForm.publishStatus == 1"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item class="scale" label="讲座管理员：" prop="userNames">
            <el-input
              class="form-dept"
              v-model="ruleForm.userNames"
              placeholder="请选择讲座管理员"
              :readonly="true"
            ></el-input>
            <el-button class="button-dept" @click="addUser">选择</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-handle form-text-center" label-width="0">
            <el-button @click="reset" v-show="!editId">重置</el-button>
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--新增用户选择-->
    <AddUserModal
      @addSucceed="addSucceed"
      :defaultCheckedKeys="allUsers"
      :showDirectMemberSelect="showAddUserDialog"
      v-if="showAddUserDialog.flag"
      @closeManage="closeAddUserDialog"
    />
  </div>
</template>

<script>
import { Confirm } from "@/components/Confirm";
import {
  saveTopicLectureInfo,
  getTopicLectureInfo,
  updateTopicLectureInfo,
} from "@/api/studyService";
import rulesFactory from "@/utils/rules";
import { setItem } from "@/utils/storage.js";
import { getSysParamByTypes } from "@/api/sysParam";
import AddUserModal from "./addUserModal.vue";
import { getIntervalCredit } from "@/api/topicLecture";

export default {
  name: "topicLectureManageAdd",
  components: { AddUserModal },
  data() {
    return {
      checkedEnrollDeptVos: [],
      topDeptList: [],
      lectureTypeData: [],
      showAddUserDialog: { flag: false },
      allUsers: [],
      resetForm: {},
      editId: null,
      ruleForm: {
        lectureType: "",
        lectureName: "",
        signDate: ["", ""],
        isScanSign: "",
        teacher: "",
        teacherUnitPosition: "",
        lectureTime: "",
        lecturePlace: "",
        organizer: "",
        userNames: "",
        manageUserSaveDtos: [],
        lectureHours: "",
        lectureStartDate: '',
        lectureEndDate: '',
      },
      publicData: [],
      rules: {
        lectureName: [
          rulesFactory.required("请输入讲座主题"),
          rulesFactory.size("最多输入100个字", 0, 100),
        ],
        lectureType: [rulesFactory.required("请选择讲座类型")],
        isScanSign: [rulesFactory.required("请选择是否扫码签到")],
        signDate: [rulesFactory.required("请选择签到时间")],
        teacher: [
          rulesFactory.required("请输入授课老师姓名"),
          rulesFactory.size("最多输入30个字", 0, 30),
        ],
        teacherUnitPosition: [
          rulesFactory.required("请输入授课老师职务职称"),
          rulesFactory.size("最多输入255个字", 0, 255),
        ],
        lectureTime: [rulesFactory.required("请选择讲座时间")],
        lectureStartDate: [rulesFactory.required("请选择开始时间")],
        lectureEndDate: [rulesFactory.required("请选择结束时间")],
        lectureHours: [
          {
            required: true,
            validator: this.limitInput,
            trigger: ['blur', 'change'],
          },
        ],
        lecturePlace: [
          rulesFactory.required("请输入讲座地点"),
          rulesFactory.size("最多输入100个字", 0, 100),
        ],
        organizer: [
          rulesFactory.required("请输入主办单位"),
          rulesFactory.size("最多输入100个字", 0, 100),
        ],
        userNames: [rulesFactory.required("请选择讲座管理员")],
      },
      calculateLectureHours: 0,
    };
  },
  created() {
    this.getSysParamByTypes(["TOPIC_LECTURE_TYPE", "IS_VALID"]);
    this.editId = this.$route.query.id;
    if (!!this.editId) {
      this.getInfo();
    }
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.lectureTypeData = res.data["TOPIC_LECTURE_TYPE"];
        // if (this.lectureTypeData.length > 0 && !this.edit) {
        //   // 设置默认选中
        //   this.ruleForm.lectureType = Number(this.lectureTypeData[0].paramKey);
        // }
        this.publicData = res.data["IS_VALID"];
        if (!this.editId) {
          // 设置默认选中
          this.ruleForm.isScanSign = Number(this.publicData[1].paramKey);
        }
      });
    },
    goBack() {
      this.$router.push("/topicLectureManage");
    },
    // 签到时间校验
    checkSignDate(rule, value, callback) {
      if ((value && value.length === 0) || !value) {
        callback(new Error("请选择签到时间"));
      } else if (value[0] == value[1]) {
        callback(new Error("开始时间不能和结束时间相等"));
      } else {
        callback();
      }
    },
    getInfo() {
      getTopicLectureInfo(this.editId).then((res) => {
        if (!res || res.code != 0) return;
        const lectureHours = res.data.lectureHours;
        let obj = Object.assign({}, res.data);
        // 先制空，等getIntervalCredit接口请求到calculateLectureHours的时候再赋值
        obj.lectureHours = ''
        if (obj.signStartDate) {
          obj.signDate = [obj.signStartDate, obj.signEndDate];
        } else obj.signDate = ["", ""];
        let namesArr = [];
        for (let i = 0; i < obj.manageUserSaveDtos.length; i++) {
          namesArr.push(obj.manageUserSaveDtos[i].userName);
        }
        obj.userNames = namesArr.join(",");
        delete obj["signStartDate"];
        delete obj["signEndDate"];
        this.ruleForm = obj;
        this.resetForm = JSON.parse(JSON.stringify(obj));
        this.allUsers = this.ruleForm.manageUserSaveDtos;
        let params = {
          lectureStartDate: obj.lectureStartDate,
          lectureEndDate: obj.lectureEndDate
        }
        const _this = this;
        getIntervalCredit(params).then((res) => {
          if (!res || res.code != 0) return;
          const time = res.data;
          
          this.ruleForm.lectureHours = lectureHours;
          
          this.calculateLectureHours = time;
          
        });
      });
    },
    // 新增用户
    addUser() {
      this.showAddUserDialog.flag = true;
    },
    closeAddUserDialog() {
      this.showAddUserDialog = { flag: false };
    },
    // 选择 讲座管理员
    addSucceed(users) {
      this.showAddUserDialog.flag = false;
      this.allUsers = users;
      this.$set(this.ruleForm, "manageUserSaveDtos", users);
      let namesArr = [];
      for (let i = 0; i < users.length; i++) {
        namesArr.push(users[i].userName);
      }
      this.ruleForm.userNames = namesArr.join(",");
    },

    // 重置表单数据
    async reset() {
      const text = "确定重置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        if (this.edit) {
            this.ruleForm = JSON.parse(JSON.stringify(this.resetForm));
          } else {
            Object.assign(this.$data.ruleForm, this.$options.data().ruleForm);
            // this.ruleForm.lectureType = Number(this.lectureTypeData[0].paramKey);
            this.ruleForm.isScanSign = Number(this.publicData[1].paramKey);
            this.ruleForm.signDate = ["", ""];
            this.ruleForm.signStartDate = "";
            this.ruleForm.signEndDate = "";
            this.ruleForm.manageUserSaveDtos = [];
          }
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    /**
     * 点击提交
     */
    submit() {
      this.$refs["ruleForm"]
        .validate()
        .then(() => {
          let params = Object.assign({}, this.ruleForm);
          params["manageUserSaveDtos"] = params["manageUserSaveDtos"].map((ele) => ({
            uuid: ele.uuid,
            userName: ele.userName,
          })),
          params["signStartDate"] = this.ruleForm.signDate[0];
          params["signEndDate"] = this.ruleForm.signDate[1];
          delete params["signDate"];
          this.requestSave(params);
        })
        .catch(() => {});
    },

    requestSave(params) {
      if (!this.editId) {
        saveTopicLectureInfo(params).then((res) => {
          if (!res || res.code != 0) return;
          setItem(this.REFRESH_FLAG, true);
          this.$message({
            message: "新增成功！",
            type: "success",
          });
          this.goBack();
        });
      } else {
        updateTopicLectureInfo(params).then((res) => {
          if (!res || res.code != 0) return;
          setItem(this.REFRESH_FLAG, true);
          this.$message({
            message: "修改成功！",
            type: "success",
          });
          this.goBack();
        });
      }
    },
    limitInput(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error("请输入学时"));
      } else if (parseFloat(value) <= 0) {
        callback(new Error("学时数需大于0"));
      } else if (parseFloat(value) > parseFloat(this.calculateLectureHours)) {        
        callback(new Error("学时要求：45分钟1学时，不足45分钟按比例换算，半天不超过4学时"));
      } else {
          callback();
      }
    },
    timeChange() {
      if (
        this.ruleForm.lectureStartDate &&
        this.ruleForm.lectureStartDate.length > 0 &&
        this.ruleForm.lectureEndDate &&
        this.ruleForm.lectureEndDate.length > 0
      ) {
        let params = {
          lectureStartDate: this.ruleForm.lectureStartDate,
          lectureEndDate: this.ruleForm.lectureEndDate
        }
        getIntervalCredit(params).then((res) => {
          if (!res || res.code != 0) return;
          const time = res.data;
          this.ruleForm.lectureHours = time;
          this.calculateLectureHours = time;
        });
      }
    },
    inputHours(value) {
      if (value != "") {
        if (value.indexOf(".") == 0) {
          this.ruleForm.lectureHours = "0.";
        } else if (value.indexOf(".") > 0) {
          this.ruleForm.lectureHours = value.slice(0, value.indexOf(".") + 3);
        } else {
          this.ruleForm.lectureHours = value;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
.devide_line {
  line-height: 32px;
  margin-left: 12px;
}
.unit_style {
  display: flex;
  flex-direction: row;
}
/deep/ .period_form .el-form-item__content {
  margin-left: 16px !important;
}
/deep/ .el-input-group__prepend {
  background-color: #909399;
  border: 0px solid #dcdfe6;
  padding: 0 0px;
}
/deep/ .scale .el-input {
  width: 50%;
  color: $textColor;
  font-size: 12px;
}
.form-select {
  width: 100%;
}
/deep/ .el-form-item__content {
  .form-dept {
    width: calc(100% - 90px);
    font-size: inherit;
  }
  .button-dept {
    margin-left: 10px;
    padding: 9px 15px;
    width: 79px;
  }
  .el-date-editor--daterange.el-input__inner {
    width: 100% !important;
  }
  .el-select.yearSelect {
    .el-input--small {
      width: 150px !important;
      margin-right: 10px;
    }
  }
}
.form-text-center {
  text-align: center !important;
}
</style>
